import React from 'react'
import PropTypes from 'prop-types'
import { useAdvisorHome } from '../../AdvisorHome/AdvisorHomeContext'
import { useMyAdvisor } from '../../../../api/groups'
import UserScopeDisplay from './UserScopeDisplay'
import GroupScopeDisplay from './GroupScopeDisplay'

const DenaliAdvisorHomeScopePicker = ({
  includeAdvisors,
  hideAvatars,
  size,
  disableReset,
  labels
}) => {
  const { scope, setScope } = useAdvisorHome()
  const { isLoading: myAdvisorLoading, data: myAdvisor } = useMyAdvisor()

  // if no scope is available, then show an unchangeable label
  if (!scope) {
    return (
      <UserScopeDisplay
        name={labels?.allItems}
        subTitle={labels?.subTitle}
        hideAvatars={hideAvatars}
        size={size}
      />
    )
  }

  // otherwise display the
  return (
    <GroupScopeDisplay
      scope={scope}
      setScope={setScope}
      includeAdvisors={includeAdvisors}
      myAdvisor={myAdvisor?.advisor}
      isLoading={myAdvisorLoading}
      hideAvatars={hideAvatars}
      size={size}
      disableReset={disableReset}
      labels={labels}
    />
  )
}

DenaliAdvisorHomeScopePicker.propTypes = {
  includeAdvisors: PropTypes.bool,
  hideAvatars: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  disableReset: PropTypes.bool,
  labels: PropTypes.shape({
    subTitle: PropTypes.string,
    allItems: PropTypes.string,
    allMyItems: PropTypes.string
  })
}

DenaliAdvisorHomeScopePicker.defaultProps = {
  size: 'lg',
  labels: {
    subTitle: 'Viewing',
    allItems: 'All Clients',
    allMyItems: 'My Clients'
  }
}

export default DenaliAdvisorHomeScopePicker
